import React from 'react';
import FullHeight from 'react-full-height';
import { Link } from 'react-router-dom';
import './home.css';

const Home = () => {
    return (
        <FullHeight className="section sectionFillViewport" id="home">
            <div className="homeHero" role="banner">
                <div className="homeHeroInner">
                    <div className="homeCard">
                        <p className="homeKicker">Naturheilpraxis &bull; Regensburg</p>
                        <h1 className="homeTitle">Nadja L&ouml;we</h1>
                        <p className="homeLead">
                            Ganzheitliche Naturheilkunde &ndash; zur Unterst&uuml;tzung und m&ouml;glichen Linderung von Beschwerden,
                            individuell auf Sie abgestimmt.
                        </p>
                        <div className="ctaRow">
                            <Link className="buttonPrimary" to="/#page-booking">
                                Termin buchen
                            </Link>
                            <Link className="buttonSecondary" to="/#page-therapies">
                                Therapien &amp; Methoden
                            </Link>
                            <Link className="buttonSecondary" to="/#page-contact">
                                Kontakt aufnehmen
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </FullHeight>
    )
}
export default Home;